<template>
  <div>
    <SeleccionCliente 
      @clientecargado="cargarInicio">
    </SeleccionCliente>
    <Ibox v-if="mostrarIndicadores()" titulo="Indicadores">
      <b-col cols="12" align="right" v-if="utils.tienePermiso()">
        <b-button v-if="loading" variant="primary"><Loading :size="'1'" :text="'Cargando widgets'"/></b-button>
        <b-button v-else-if="configuracion.editing" variant="primary"><Loading :size="'1'" :text="'Guardando configuración'"/></b-button>
        <span v-else-if="configuracion.configurando">
          <b-button variant="danger" style="margin-right:10px" v-on:click="cerrarConfiguracion()">Cerrar configuración</b-button>
          <b-button variant="primary" v-on:click="guardarConfiguracion()">Guardar configuración</b-button>
        </span>
        <b-button v-else variant="primary" v-on:click="configurarInicio()">Configurar inicio</b-button>
      </b-col>
      <template v-for="(objeto, key, index) in data">
        <b-col :key="index" :cols="objeto.ancho" :class="classConfigurando()">
          <div v-if="configuracion.configurando">
            <a href="javascript:void(0)" v-on:click="quitarWidget(objeto)">Quitar widget</a>
            |
            <a href="javascript:void(0)" v-on:click="mostrarReemplazarWidget(objeto, key)">Reemplazar widget</a>
          </div>
          <WidgetAgregar
            v-if="objeto.reemplazar == 'S' && configuracion.configurando"
            :tipo="'reemplazar'"
            :ancho="objeto.ancho"
            :index="key"
            @agregar-widget=agregarWidget
            @reemplazar-widget=reemplazarWidget
            @modificacion-widget=modificarWidget
          ></WidgetAgregar>
          <div v-else>
          <TablaAvance
            v-if="objeto.function == 'programaTabla'"
            :titulo="objeto.nombre_widget">
          </TablaAvance>
          <TablaAvanceFecha
            v-if="objeto.function == 'programaTablaFecha'"
            :titulo="objeto.nombre_widget">
          </TablaAvanceFecha> 
          <ReportePersonalizado
            v-if="objeto.function == 'formularioReporte'"
            :id_reporte="objeto.id_widget"
            :titulo="objeto.nombre_widget">
          </ReportePersonalizado>
          <FormularioTablaIndicadores
            v-if="objeto.function == 'formularioTabla'"
            :titulo="objeto.nombre_widget">
          </FormularioTablaIndicadores> 
          <FormularioTortaCategoria
            v-if="objeto.function == 'formularioTortaCategoria'"
            :titulo="objeto.nombre_widget">
          </FormularioTortaCategoria> 
          <FormularioTortaEstado
            v-if="objeto.function == 'formularioTortaEstado'"
            :titulo="objeto.nombre_widget">
          </FormularioTortaEstado> 
          <InspeccionTortaTipo
            v-if="objeto.function == 'inspeccionTortaTipo'"
            :titulo="objeto.nombre_widget">
          </InspeccionTortaTipo> 
          <InspeccionTortaImportancia
            v-if="objeto.function == 'inspeccionTortaImportancia'"
            :titulo="objeto.nombre_widget">
          </InspeccionTortaImportancia> 
          <InspeccionTortaEstado
            v-if="objeto.function == 'inspeccionTortaEstado'"
            :titulo="objeto.nombre_widget">
          </InspeccionTortaEstado> 
          <InspeccionTablaIndicadoresSucursal
            v-if="objeto.function == 'inspeccionTabla'"
            :titulo="objeto.nombre_widget">
          </InspeccionTablaIndicadoresSucursal> 
          <TareaTortaCategoria
            v-if="objeto.function == 'tareaTortaCategoria'"
            :titulo="objeto.nombre_widget">
          </TareaTortaCategoria> 
          <TareaTortaPrioridad
            v-if="objeto.function == 'tareaTortaPrioridad'"
            :titulo="objeto.nombre_widget">
          </TareaTortaPrioridad> 
          <TareaTortaEstado
            v-if="objeto.function == 'tareaTortaEstado'"
            :titulo="objeto.nombre_widget">
          </TareaTortaEstado> 
          <TareaTablaIndicadores
            v-if="objeto.function == 'tareaTabla'"
            :titulo="objeto.nombre_widget">
          </TareaTablaIndicadores>
          <RvcIpaKpi
            v-if="objeto.function == 'indicadoresIpa'"
            :titulo="objeto.nombre_widget">
          </RvcIpaKpi>
          <RvcIpaMantenedor
            v-if="objeto.function == 'mantenedorIpa'"
            :titulo="objeto.nombre_widget">
          </RvcIpaMantenedor>
          <CmpcDiasPerdidosMantenedor
            v-if="objeto.function == 'mantenedorDiasPerdidos'"
            :titulo="objeto.nombre_widget">
          </CmpcDiasPerdidosMantenedor>
          <CmpcDiasPerdidosTabla
            v-if="objeto.function == 'indicadoresDiasPerdidos'"
            :titulo="objeto.nombre_widget">
          </CmpcDiasPerdidosTabla>
          </div>
        </b-col>
      </template>
      <b-col v-if="configuracion.configurando" :cols="widget.ancho">
        <WidgetAgregar
          :tipo="'agregar'"
          :ancho="widget.ancho"
          @agregar-widget=agregarWidget
          @reemplazar-widget=reemplazarWidget
          @modificacion-widget=modificarWidget
        ></WidgetAgregar>
      </b-col>
    </Ibox>
    <Ibox v-else :titulo="'Tutoriales'">
      <b-col cols="12">
        <h1>Tutoriales</h1>
        <h2>Inspección</h2>
      </b-col>
      <b-col cols="6">
        <iframe width="100%" height="315" src="https://www.youtube.com/embed/MTb0lc8W5Og" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </b-col>
      <b-col cols="6">
        <iframe width="100%" height="315" src="https://www.youtube.com/embed/qIo6D6XHS6c" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </b-col>
      <b-col cols="6">
        <iframe width="100%" height="315" src="https://www.youtube.com/embed/3H1qvfPO6bA" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </b-col>
      <br><br>

      <b-col cols="12">
        <h2>Formulario</h2>
      </b-col>  
      <b-col cols="6">
        <iframe width="100%" height="315" src="https://www.youtube.com/embed/2JrrFLMVBMc" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </b-col>
    </Ibox>
  </div>
</template>

<script>

import { widgetService, globales } from "@/services";
import { utils } from "@/helpers";

import TablaAvanceFecha from '../widgets/programa/TablaAvanceFecha.vue';
import TablaAvance from '../widgets/programa/TablaAvance.vue';
import ReportePersonalizado from '../widgets/formulario/ReportePersonalizado.vue';
import FormularioTablaIndicadores from '../widgets/formulario/TablaIndicadores.vue';
import FormularioTortaCategoria from '../widgets/formulario/TortaCategoria.vue';
import FormularioTortaEstado from '../widgets/formulario/TortaEstado.vue';
import InspeccionTortaTipo from '../widgets/inspeccion/TortaTipo.vue';
import InspeccionTortaImportancia from '../widgets/inspeccion/TortaImportancia.vue';
import InspeccionTortaEstado from '../widgets/inspeccion/TortaEstado.vue';
import InspeccionTablaIndicadoresSucursal from '../widgets/inspeccion/TablaIndicadoresSucursal.vue';
import TareaTortaCategoria from '../widgets/tarea/TortaCategoria.vue';
import TareaTortaPrioridad from '../widgets/tarea/TortaPrioridad.vue';
import TareaTortaEstado from '../widgets/tarea/TortaEstado.vue';
import TareaTablaIndicadores from '../widgets/tarea/TablaIndicadores.vue';
import WidgetAgregar from '../widgets/Agregar.vue';
import RvcIpaKpi from '../widgets/clientes/rvc/IpaKpi.vue'
import RvcIpaMantenedor from '../widgets/clientes/rvc/IpaMantenedor.vue'
import CmpcDiasPerdidosTabla from '../widgets/clientes/cmpc/DiasPerdidosTabla.vue'
import CmpcDiasPerdidosMantenedor from '../widgets/clientes/cmpc/DiasPerdidosMantenedor.vue'

import SeleccionCliente from '../../components/SeleccionCliente.vue'

export default {
  components: { 
    TablaAvance, 
    TablaAvanceFecha, 
    ReportePersonalizado, 
    FormularioTablaIndicadores,
    FormularioTortaCategoria, 
    FormularioTortaEstado,
    InspeccionTortaTipo, 
    InspeccionTortaImportancia, 
    InspeccionTortaEstado, 
    InspeccionTablaIndicadoresSucursal, 
    TareaTortaCategoria, 
    TareaTortaPrioridad, 
    TareaTortaEstado, 
    TareaTablaIndicadores,
    WidgetAgregar,
    RvcIpaKpi,
    RvcIpaMantenedor,
    CmpcDiasPerdidosTabla,
    CmpcDiasPerdidosMantenedor,
    SeleccionCliente
  },
  data() {
    return {
      loading:true,
      configuracion: {
        configurando: false,
        editing:false
      },
      utils,
      data:[],
      widget:{
        ancho:'4'
      }
    }
  },
  mounted(){
    this.cargarInicio();
  },
  methods : {
    mostrarIndicadores(){
      if(this.$store.state.usuario.perfiles.find((element) => element.id_perfil == globales.perfil.admin) ||
        this.$store.state.usuario.perfiles.find((element) => element.id_perfil == globales.perfil.admin_cliente) ||
        this.$store.state.usuario.perfiles.find((element) => element.id_perfil == globales.perfil.admin_sucursal) ||
        this.$store.state.usuario.perfiles.find((element) => element.id_perfil == globales.perfil.admin_categoria)){
        return true;
      }
      return false;
    },
    modificarWidget(data, index){
      if(typeof(index) == "undefined"){
        this.widget.ancho = data.ancho;
      }else{
        this.data[index].ancho = data.ancho;
      }
    },
    agregarWidget(data){
      this.data.push(data);
    },
    mostrarReemplazarWidget(objeto, index){
      objeto.reemplazar = 'S';
      this.$set(this.data, index, objeto);
    },
    reemplazarWidget(data, index){
      this.$set(this.data, index, data);
    },
    quitarWidget(objeto){
      this.data = this.data.filter((element) => element != objeto);
    },
    configurarInicio(){
      this.configuracion.configurando = true;
    },
    cerrarConfiguracion(){
      this.configuracion.configurando = false;
      this.cargarInicio();
    },
    guardarConfiguracion(){
      this.configuracion.editing = true;
      this.configuracion.configurando = false;

      widgetService.postWidgetInicio({
        id_usuario:this.$store.state.usuario.id_usuario,
        data:this.data
      }).then(respuesta  => {
        if(respuesta.status == 'success'){
          this.cerrarConfiguracion();
        }else{
          utils.alerta(respuesta);
        }
        this.configuracion.editing = false;
      });
    },
    cargarInicio(){
      this.loading = true;

      widgetService.getWidgetInicio({
        id_usuario:this.$store.state.usuario.id_usuario
      }).then(respuesta => {
        this.data = respuesta.data;
        this.loading = false;
      });
    },
    classConfigurando(){
      if(this.configuracion.configurando){
        return 'configurando';
      }
    }
  },
  
}
</script>

<style scoped>
  .configurando {
    border: 1px dashed black;
    margin-bottom: 5px;
    margin-top: 5px;
  }
</style>
